export const DEFAULT_ORGANIZATION = 'none';
export const DEFAULT_ORGANIZATION_OPTION = { value: 'none', label: 'None' };